import React from 'react';
/* eslint import/no-webpack-loader-syntax: off */
import RubSvg from '!url-loader!./symbols/rub.svg'
import EditSvg from '!url-loader!./symbols/edit.svg'

export function Rub (props) {
    return <img 
        className="tickets-rub"
        //src="/img/rub.svg" 
        src={RubSvg}
        height={props.height || 18} 
        alt="руб."  />
}

export function Line (props) {
    return (
        <div className={'tickets-line ' + (props.className || '')}>&nbsp;</div>
    )
}

export function RedLine (props) {
    return (
        <div className={'tickets-redline ' + (props.className || '')}>&nbsp;</div>
    )
}

export function Edit (props) {
    return (
        <img 
            alt={props.alt} 
            height={props.height || 23}
            src={EditSvg} />
    )
}
